// extracted by mini-css-extract-plugin
export default {"cta":"UE-z","disabled":"VE-z"};